import { render, staticRenderFns } from "./purchaseOrderSuccess.vue?vue&type=template&id=90fd1ef6&"
import script from "./purchaseOrderSuccess.vue?vue&type=script&lang=js&"
export * from "./purchaseOrderSuccess.vue?vue&type=script&lang=js&"
import style0 from "./purchaseOrderSuccess.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports